import $ from 'jquery';
import ContentSyncSlider from '../../components/content-sync-slider';
import RevealWhenVisible from '../../components/reveal-when-visible';
import TabbedFeature from '../../components/tabbed-feature';
import VideoModalButton from '../../components/video-modal-button';
import FirstStepsGaTracking from './components/ga-tracking';
$(() => {
    FirstStepsGaTracking.init();
    ContentSyncSlider.init((activeIndex, $root) => FirstStepsGaTracking.trackSlideActivation(activeIndex, $root));
    TabbedFeature.init((activeIndex, $root) => FirstStepsGaTracking.trackSlideActivation(activeIndex, $root));
    VideoModalButton.init();
    RevealWhenVisible.init();
});
